var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedTrashLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    clipPath: "url(#clip0_15439_6398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.5 5.77865H4.16667M4.16667 5.77865H17.5M4.16667 5.77865V17.4453C4.16667 17.8873 4.34226 18.3113 4.65482 18.6238C4.96738 18.9364 5.39131 19.112 5.83333 19.112H14.1667C14.6087 19.112 15.0326 18.9364 15.3452 18.6238C15.6577 18.3113 15.8333 17.8873 15.8333 17.4453V5.77865H4.16667ZM6.66667 5.77865V4.11198C6.66667 3.66995 6.84226 3.24603 7.15482 2.93347C7.46738 2.62091 7.89131 2.44531 8.33333 2.44531H11.6667C12.1087 2.44531 12.5326 2.62091 12.8452 2.93347C13.1577 3.24603 13.3333 3.66995 13.3333 4.11198V5.77865M8.33333 9.94531V14.9453M11.6667 9.94531V14.9453",
    stroke: "#F04438",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15439_6398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.777344)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrashLine);
export default __webpack_public_path__ + "static/media/redTrashLine.aec63c85720bbfa9b42edac80bbf74e3.svg";
export { ForwardRef as ReactComponent };